import React from 'react';
import Icons from '../../../Containers/Icons';
import Permissions from '../Permissions'

let UserTabs = (props) => {
  let {tabs, uID, tkn, url} = props;
  return (
    <div className="tabConf">
      <ul>
      {
        Object.keys(tabs).map(key => {
          return(
            <li key={key}>
              <div className="tabConfTab">
                <div className="tabName">{tabs[key].name}</div>
                <div className="arrow gray"><Icons name="arrowThin" /></div>
                <div className="tabFullname">{tabs[key].fullname}</div>
              </div>
              <Permissions 
                readtabs={props.readUserDetails}
                url={url}
                uID={uID} 
                view={tabs[key].view} 
                edit={tabs[key].edit} 
                tabID={tabs[key].id}
                tkn={tkn}/>
            </li>
          )
        })
      }
      </ul>
    </div>
  )
}

export default UserTabs;


// WEBPACK FOOTER //
// ./src/Components/Admin/User/UserTabs.js